import { combineReducers } from 'redux'

import app from './root/app'
import entities from './root/entities'
import print from './root/print'

export default combineReducers({
  app,
  entities,
  print
})



// WEBPACK FOOTER //
// ./src/reducers/root.js